import React, { useState } from "react";

import axios from 'axios';
import * as api from '../services/api';

const FileUploadDD = () => {
    const [files, setFiles] = useState([]);
    const [respStatus, setRespStatus] = useState();

    const primaryButtonClass = "px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#0062cc] hover:bg-[#0052ac] disabled:opacity-50 disabled:cursor-not-allowed mt-10";

    const [uploadProgress, setUploadProgress] = useState(0);
    // Handle file selection from input or drop
    const handleFiles = (selectedFiles) => {
        const newFiles = Array.from(selectedFiles);
        setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    };

    // Handle manual file selection
    const handleInputChange = (event) => {
        handleFiles(event.target.files);
    };

    // Handle drag-and-drop
    const handleDrop = (event) => {
        event.preventDefault();
        handleFiles(event.dataTransfer.files);
    };

    // Prevent default drag behaviors
    const handleDragOver = (event) => {
        event.preventDefault();
    };

    const handleMultipleUpload = async () => {
        uploadAPI()
    }



    const uploadAPI = async () => {
        let type = 'training';
        const progressBar = document.getElementById(type === 'training' ? "progressBar11" : "classificationProgress");
        const progressBarFill = document.getElementById(type === 'training' ? "progressBarFill11" : "classificationProgressFill");
        progressBar.style.display = "block";

        try {

            const formData = new FormData();
            //formData.append('files', new File([new Blob()], 'predictions (7).csv', { type: 'text/csv' }));
            formData.append('s3_prefix', 's3_upload_api');
            files?.map((lfile, index) => {
                formData.append('files', lfile, `${lfile.name}.csv`, { type: 'text/csv' });
            })

            // Define the progress callback for Axios
            const onUploadProgress = (progressEvent) => {
                if (progressEvent.total) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percentCompleted);
                } else {
                    // Handle indeterminate progress if total size is not available
                    setUploadProgress(50); // Example: set to 50% or use a different visual indicator
                }
            };

            const result = await api.uploadAnalyticalData(formData, onUploadProgress);
            // If upload was successful and callback exists, call it
            if (result) {
                console.log('sss', result);

            }

            // const response = await axios.post(process.env.REACT_APP_API_BASE_URL + '/api/v1/data-transfer/upload',
            //     formData,
            //     {
            //         headers: {
            //             "Content-Type": "multipart/form-data",
            //             Accept: "application/json",
            //         },
            //         onUploadProgress: (progressEvent) => {
            //             const percentCompleted = Math.round(
            //                 (progressEvent.loaded * 100) / progressEvent.total
            //             );
            //             progressBarFill.style.width = percentCompleted + "%";
            //         },
            //     });
            // console.log('Upload Success:', response.data);

            // if (response.data.status === 'started') {



            //     setTimeout(() => {
            //         processingStatusApi(response.data.task_id)
            //     }, 3000);

            // } else {
            //     alert('Files uploaded api error')
            // };

        } catch (error) {
            console.error('Error uploading files:', error);
            alert('Error uploading files');
        }
        finally {
            setTimeout(() => {
                progressBar.style.display = "none";
                progressBarFill.style.width = "0%";
            }, 1000);
        }
    }

    const processingStatusApi = async (task_id) => {

        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/api/v1/data-transfer/status/${task_id}`   //10_1
            );


            console.log(response.data);

            setRespStatus(response.data)

            // if (status == 'processing') {

            // }
            // else if (status == 'completed') {


            // } else {
            //     document.getElementById("processStatus").style.display = "block";

            // }





        } catch (error) {


        }

    }


    return (
        <div style={{ backgroundColor: 'white', padding: 20 }}>
            <h4 >Upload Analytics Files -</h4>
            <label htmlFor="fileInput" style={{
                width: "100%",
                padding: "20px",
                textAlign: "center",
                cursor: "pointer",
                display: "block",
                marginTop: "10px",
                border: "2px dashed #aaa",
                cursor: "pointer"
            }}
                onDragOver={handleDragOver}
                onDrop={handleDrop}>
                Drag & drop files here or click here to select files


            </label>
            {/* File Input (Hidden) */}
            <input
                type="file"
                accept=".csv"
                multiple
                onChange={handleInputChange}
                style={{ display: "none" }}
                id="fileInput"
            />
            {/* <label htmlFor="fileInput" style={{ display: "block", marginTop: "10px", cursor: "pointer" }}>
                Click to select files
            </label> */}

            {/* Display Selected Files */}
            <ul>
                {files?.map((file, index) => (
                    <li key={index}>{file.name} ({(file.size / 1024).toFixed(2)} KB)</li>
                ))}
            </ul>
            {files.length > 0 &&
                <span
                    title='Download the sample file'
                    style={{ marginLeft: '20px', color: 'blueviolet', textDecorationLine: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                        setFiles([])
                    }}>Clear selection</span>
            }
            <button className={primaryButtonClass} onClick={handleMultipleUpload}>Upload Files</button>
            {uploadProgress > 0 && (
                <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2.5 my-1">
                    <div className="bg-[#0062cc] h-2.5 rounded-full" style={{ width: `${uploadProgress}%` }}></div>
                </div>
            )}
            <div id="progressBar11" className="progress-bar" style={{ display: 'none' }}>
                <span id="progressBarFill11" className="progress-bar-fill" style={{ width: '0%' }}></span>
            </div>

            {respStatus &&
                <>
                    <label className={'status success'}>{respStatus?.message}.</label>
                    <label className={'status success'}>Uploaded files = {respStatus?.successful_uploads}</label>
                </>}
        </div>
    );
};

export default FileUploadDD;
